import React from 'react';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

export default function Button({
	children,
	variant = 'primary',
	size = 'md',
	className = '',
	...props
}) {
	const base = 'inline-flex items-center justify-center font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-1 dark:focus:ring-offset-slate-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200';
	const variants = {
		primary: 'text-white bg-orange-600 hover:bg-orange-700 focus:ring-orange-500 shadow-sm dark:bg-orange-600 dark:hover:bg-orange-500',
		secondary: 'text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 focus:ring-slate-500 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-600 dark:hover:bg-slate-700',
		danger: 'text-white bg-red-600 hover:bg-red-700 focus:ring-red-500 shadow-sm',
		ghost: 'text-slate-700 hover:bg-slate-100 focus:ring-slate-500 dark:text-slate-300 dark:hover:bg-slate-800',
		success: 'text-white bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500 shadow-sm',
	};
	const sizes = {
		sm: 'px-2 py-1 text-[11px]',
		md: 'px-3 py-1.5 text-xs',
		lg: 'px-3.5 py-1.5 text-xs',
		xl: 'px-4 py-2 text-sm',
	};

	return (
		<button
			className={classNames(base, variants[variant], sizes[size], className)}
			{...props}
		>
			{children}
		</button>
	);
}


